<template>
    <div id="quotation">
        <nav class="printableNo">
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outermargin printableNo">
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
        </div>
        <div class="pdfcontainer">
            <div v-if="numPages === 1">
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <div v-else>
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <img :src="sig" class="imgOverPdf">
        </div>
        <div class="outercircle printableNo">
            <span class="sigBot">Signature :</span>
            <VueSignaturePad  width="400px" height="150px" :class="sigpadclass" ref="signaturePad" />
            <button class="docBtn" :title="title" type="button" :disabled="validated" v-on:click="validatePDF()">Valider la signature du devis</button>   
            <button class="docBtn2" :title="title2" type="button" :disabled="!validated" v-on:click="print()">Enregistrer le devis en PDF</button>            
        </div>
    </div>
</template>

<script>
    import pdf from 'vue-pdf';
    import axios from 'axios';
    export default {
        name: 'Quotation',
        components: {
            pdf
        },
        data() {
            return {
                Name:"client",
                quotation: {},
                pdfLink: "/assets/facture.pdf",
                sig: "/assets/nosignature.png",
                numPages: 1,
                validated: false,
                sigpadclass: "signature",
                title: "Valider la signature du devis",
                title2: "Veuillez valider le devis afin de l'enregistrer"
            };
        },
        methods:{
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "home" });
            },
            validatePDF() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                if(isEmpty){
                    alert("Vous devez signer le document pour le valider");
                }
                else{
                    this.sig = data;
                    this.putSignature();
                }
            },
            print() {
                window.print();
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('fromQuery');
                this.$cookie.delete('fromPage');
                this.$cookie.delete('fromPagePrev');
                this.$cookie.delete('fromQueryPrev');
                this.$router.replace({ name: "login" });
            },
            backbtn(){
                if(this.$cookie.get('fromQuery') !== ""){
                    this.$router.replace({ name: this.$cookie.get('fromPage'), query: {name: this.$cookie.get('fromQuery')} });
                }
                else{
                    this.$router.replace({ name: this.$cookie.get('fromPage') });
                }
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            async putSignature(){
                var file = this.dataURLtoFile(this.sig, 'picture.png');
                const fd = new FormData();
                fd.append('picture', file ,"picture.png");

                var response = await axios.put('https://so.gaviota.fr/api/building/quotation/'+this.$route.query.id+'/'+this.$route.query.name, fd)
                console.log(response);
                if(response){
                    this.validated = true;
                    this.title = "Devis dejà validé";
                    this.title2 = "Enregistrer le devis";
                    this.sigpadclass = "signaturedisable";
                    this.$refs.signaturePad.lockSignaturePad()
                    console.log("device validé !");
                }
            },
            async getQuotation(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/quotation/'+this.$route.query.name)
                if(response.data.quotation){
                    this.quotation = response.data.quotation;
                    if(this.quotation.pdf){
                        this.pdfLink = 'data:'+this.quotation.pdf.img.contentType+';base64,' + btoa(
                            new Uint8Array(this.quotation.pdf.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                        pdf.createLoadingTask(this.pdfLink).then(pdf => {
                            this.numPages = pdf.numPages;
                            console.log(this.numPages)
                        });
                    
                        if(this.quotation.signature){
                            this.validated = true;
                            this.title = "Devis dejà validé";
                            this.title2 = "Enregistrer le devis";
                            this.sigpadclass = "signaturedisable";
                            console.log("device validé !");
                            
                            this.sig = 'data:'+this.quotation.signature.img.contentType+';base64,' + btoa(
                                new Uint8Array(this.quotation.signature.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                            );
                            this.$refs.signaturePad.fromDataURL(this.sig)
                            this.$refs.signaturePad.lockSignaturePad()
                        }
                    }
                }
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') !== "client" || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getQuotation();
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #quotation {
        background-color: #F0F0F0;
        margin: auto;
        border:none;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        font-size: 30px;
        margin-top:80px;
        margin-left:50px;
        background-color: #F0F0F0;
    }
    .pdfcontainer{
        width:800px;
        margin: auto;
        position: relative;
    }
    .pdfViewer{
        width:100%;
    }
    .imgOverPdf{
        position: absolute;
        bottom:1250px;
        right:140px;
        width:140px;
        height:53px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
        width: 800px;
        margin:auto;
        position: relative;
    }
    .docBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        margin:0px;
        margin-bottom:50px;
        margin-right:100px;
        width: 200px;
        position: absolute;
        top: 107px;
        right: 0px;
    }
    .docBtn2{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        margin:0px;
        margin-bottom:50px;
        margin-right:100px;
        width: 200px;
        position: absolute;
        top: 166px;
        right: 0px;
    }
    button:disabled, button[disabled] {
        border: 1px solid #999999;
        background-color: #cccccc;
        color: #666666;
        cursor: no-drop;
    }
    .signature{
        display: inline-block;
        border: 2px solid;
        border-color:#888;
        background-color: white;
    }
    .signaturedisable{
        display: inline-block;
        border: 2px solid;
        border-color:#888;
        background-color: #cccccc;
        cursor: no-drop;
    }
    .sigBot{
        font-family: 'BenchNine', sans-serif;
        display: block;
        font-size: 18px;
    }
    @media print {
        .printableNo {display:none;}
    }
    @page { size: auto; margin: 0mm; }
</style>